<template>
    <ul class="select-shipping" v-if="shippingTypesSafe.length">
        <Swiper
            class="swiper shipping-slider"
            :modules="[Navigation]"
            :spaceBetween="swiperOptionTop.spaceBetween"
            :slides-per-view="swiperOptionTop.slidesPerView"
            :breakpoints="swiperOptionTop.breakpoints"
            ref="swiperTop">
            <SwiperSlide
                class="swiper-slide"
                v-for="(shippingItem, index) in shippingTypesSafe"
                :key="shippingItem.id">
                <div class="slide-inner">
                    <input
                        type="radio"
                        class="filter-shipping__checkbox checkout__checkbox"
                        :id="`shipping-${shippingItem.id}`"
                        name="shipping_id"
                        :value="shippingItem.id"
                        v-model="shippingSelectLocal">
                    <label
                        :for="`shipping-${shippingItem.id}`"
                        class="shipping-label checkout-input-label"
                        :title="shippingItem.name">
                        <svg class="svg-icon xl" data-role="button" aria-hidden="true" v-if="shippingItem.id < 4">
                            <use v-if="shippingItem.id === 1" xlink:href="#icon-pickup">
                                <svg id="icon-pickup" :test="shippingItem.id" viewBox="0 0 1024 1024">
                                    <path d="M346.24 829.376l7.68 12.16a12.032 12.032 0 0 1-3.904 16.768l-59.968 35.968a11.968 11.968 0 1 1-12.352-20.544l49.408-29.696-131.008-207.68-49.92 29.952a11.968 11.968 0 1 1-12.352-20.544l59.968-36.032a11.968 11.968 0 0 1 16.32 3.904l16.64 26.368 69.248-44.224V152C296 138.752 306.752 128 320 128h504c13.248 0 24 10.752 24 24v383.616c16 4.48 30.272 14.976 39.232 30.464a66.176 66.176 0 0 1-24.192 90.176l-232.96 132.8a83.968 83.968 0 0 1-41.536 10.944H411.712a59.84 59.84 0 0 0-30.848 8.576l-34.56 20.8z m-12.8-20.288l35.072-21.12a83.84 83.84 0 0 1 43.2-11.968h176.832a59.968 59.968 0 0 0 29.696-7.808l232.832-132.8a42.176 42.176 0 0 0 15.36-57.344 42.112 42.112 0 0 0-57.344-15.36l-159.552 91.776a11.968 11.968 0 0 1-8.512 1.28 65.92 65.92 0 0 1-51.008 24.32H452.032a12.032 12.032 0 0 1 0-24.064h137.984c23.04 0 41.984-18.88 41.984-41.984a42.112 42.112 0 0 0-41.984-41.984H395.2a59.968 59.968 0 0 0-32.32 9.408l-123.328 78.848 93.888 148.8zM320 580.416l29.952-19.2c13.568-8.576 29.248-13.184 45.248-13.184H590.08a66.112 66.112 0 0 1 65.28 75.392l141.824-81.536c8.512-4.864 17.664-7.68 26.88-8.512V152h-156.032v108.032a12.032 12.032 0 0 1-15.744 11.328l-32.704-10.88-44.608 11.2a11.968 11.968 0 0 1-5.824 0l-44.608-11.2-32.64 10.88a12.032 12.032 0 0 1-15.808-11.328V152H320v428.416z m323.968-428.416h-144v91.328l20.224-6.72a11.968 11.968 0 0 1 6.72-0.256l45.056 11.264 45.12-11.264a11.968 11.968 0 0 1 6.72 0.256l20.16 6.72V152z m0 348.032v-24h120v24h-120z"></path>
                                </svg>
                            </use>
                            <use v-if="shippingItem.id === 2" xlink:href="#icon-pickup-delivery">
                                <svg id="icon-pickup-delivery" viewBox="0 0 1024 1024">
                                    <path d="M680 212.032a84.032 84.032 0 1 1-3.456-24.064h51.456c16 0 16 24.064 0 24.064h-48z m-24 0H571.968c-16 0-16-24.064 0-24.064h79.04a60.032 60.032 0 1 0 4.992 24.064z m0 240v-48a11.968 11.968 0 0 1-7.936-3.008 708.096 708.096 0 0 0-12.352-10.624 1237.824 1237.824 0 0 0-35.328-28.992c-16.896-13.184-30.08-22.4-37.184-25.6-23.04-10.496-49.728-8.384-64.64 13.824L404.224 526.528l5.952 71.104 1.792 1.408 108.032 96c1.92 1.728 3.2 4.032 3.776 6.592l32.128 160.704c1.152 5.632 6.08 9.664 11.776 9.664h94.336a17.984 17.984 0 1 0 0-36.032h-41.088a12.032 12.032 0 0 1-11.776-9.92L586.88 697.6a48.128 48.128 0 0 0-10.176-22.208L478.72 555.584c-9.6-11.776 7.04-26.88 17.792-16.064l12.16 12.224 64.64-129.088a12.032 12.032 0 0 1 17.92-4.288l44.8 33.664h19.968z m24 0h84.032a24 24 0 1 0 0-48h-84.032v48z m-24-75.904V308.032c0-6.656 5.376-12.032 12.032-12.032h215.936c6.656 0 12.032 5.376 12.032 12.032v240a11.968 11.968 0 0 1-12.032 11.968h-215.936a11.968 11.968 0 0 1-12.032-12.032V476.032h-24a11.968 11.968 0 0 1-7.232-2.432l-36.48-27.392-63.744 127.488 70.784 86.528c7.808 9.6 13.056 21.056 15.168 33.28l20.544 118.464h30.976a41.984 41.984 0 1 1 0 84.032H567.68c-17.152 0-32-12.16-35.328-28.928l-31.36-156.8-87.936-78.208 2.88 34.944a11.968 11.968 0 0 1-2.304 8.192l-20.096 26.752a48 48 0 0 1-54.592 16.448l-126.976-45.376v24.96a42.112 42.112 0 0 1-53.248 40.512 42.624 42.624 0 0 1-30.72-41.6V592.128c0-24.064 23.04-41.344 46.4-34.496l152.32 48.192 50.88-81.344c1.536-2.816 2.944-5.12 4.224-6.784L478.016 337.28c23.424-35.136 62.592-38.144 95.104-23.424 9.408 4.288 23.68 14.208 42.048 28.608l7.168 5.632a1261.248 1261.248 0 0 1 33.664 27.968z m24 3.84h84.032a48 48 0 1 1 0 96h-84.032v60.032h192V320h-192v59.968zM369.92 581.952l-27.776 44.416a11.968 11.968 0 0 1-13.76 5.12L167.36 580.48a11.968 11.968 0 0 0-15.36 11.52v104.896c0 8.704 5.44 16.32 12.992 18.368 11.84 3.2 23.04-5.568 23.04-17.28v-42.048c0-8.32 8.192-14.08 16-11.328l143.04 51.072a24 24 0 0 0 27.264-8.192l17.28-23.104-4.544-55.232a70.656 70.656 0 0 1-17.152-27.264zM427.968 320H296.064c-16 0-16-24 0-24h132.032c16 0 16 24 0 24zM224 320h-24c-16 0-16-24 0-24H224c16 0 16 24 0 24z m60.032 120h-144c-16 0-16-24 0-24h144c16 0 16 24 0 24z m48-228.032H176c-16 0-16-23.936 0-23.936h156.032c16 0 16 23.936 0 23.936z"></path>
                                </svg>
                            </use>
                            <use v-if="shippingItem.id === 3" xlink:href="#icon-pickup-tk">
                                <svg id="icon-pickup-tk" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 52">
                                    <defs/>
                                    <path  fill-rule="evenodd"
                                           d="M40 51a1 1 0 01-1 1h-2a1 1 0 010-2h2a1 1 0 011 1m20 0a1 1 0 01-1 1H43a1 1 0 010-2h16a1 1 0 011 1m-28 0a1 1 0 01-1 1H21a1 1 0 010-2h10a1 1 0 011 1m-16 0a1 1 0 01-1 1H1a1 1 0 010-2h14a1 1 0 011 1M2 31a1 1 0 011-1h2.84l-.42-2.85a1 1 0 011.98-.3L7.86 30H15a1 1 0 010 2H3a1 1 0 01-1-1m1-9h1.56l-.42-2.85a1 1 0 011.97-.3L6.58 22H15a1 1 0 010 2H3a1 1 0 010-2m12 20a1 1 0 110-2 1 1 0 010 2m0-4a3 3 0 100 6 3 3 0 000-6m34 4a1 1 0 110-2 1 1 0 010 2m0-4a3 3 0 100 6 3 3 0 000-6m0 8a5 5 0 11.01-10.01A5 5 0 0149 46m9.7-20.7l-2.73-2.75L55 11a5 5 0 00-5-5h-7a1 1 0 000 2h7c1.63 0 3 1.37 3 3.08L53.91 22h-3.3l1.29-2.55a1 1 0 00-1.8-.9L48.38 22H43a1 1 0 000 2h11.59l2.7 2.7c.57.58.7 1.89.71 2.3v11h-2.08a7 7 0 100 2H59a1 1 0 001-1V29c0-.25-.04-2.45-1.3-3.7M15 46a5 5 0 11.01-10.01A5 5 0 0115 46M39 0H7a5 5 0 00-4.99 5.15L3.34 14H1a1 1 0 000 2h14a1 1 0 000-2H5.36L4 4.93A3 3 0 017 2h31v38H21.92a7 7 0 100 2H39a1 1 0 001-1V1a1 1 0 00-1-1"/>
                                </svg>
                            </use>
                        </svg>
                        <img class="shipping-icon-png" v-if="shippingItem.id === 4" src="/assets/images/yandex_go_2.png" alt="yandex-go" />
                        <div class="shipping-name checkout-field-name">{{ shippingItem.name }}</div>
                    </label>
                </div>
            </SwiperSlide>
        </Swiper>
        <div class="shipping-description" v-html="shippingDescription"></div>
    </ul>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import { useStore } from 'vuex'
const store = useStore()

const swiperTop = ref(null)

const swiperOptionTop = {
    spaceBetween: 20,
    slidesPerView: 3,
    breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 10 },
        568: { slidesPerView: 2 },
        800: { slidesPerView: 3, spaceBetween: 20 },
        992: { slidesPerView: 2, spaceBetween: 30 },
        1400: { slidesPerView: 3, spaceBetween: 20 }
    }
}

// --- Получаем данные из стора (всегда массив)
const shippingTypesSafe = computed(() => {
    const arr = store.getters.shippingTypes
    return Array.isArray(arr) ? arr : []
})
const paymentSelect = computed(() => store.getters.paymentSelect)

// --- Локальное выбранное значение (реактивное, синхронизируется со стором)
const shippingSelectLocal = ref(
    shippingTypesSafe.value.length ? shippingTypesSafe.value[0].id : 1
)

// --- Синхронизация стора и локального значения
watch(shippingTypesSafe, (newTypes) => {
    if (newTypes.length && !newTypes.find(x => x.id === shippingSelectLocal.value)) {
        shippingSelectLocal.value = newTypes[0].id
        store.commit('setShippingSelect', shippingSelectLocal.value)
    }
}, { immediate: true })

watch(shippingSelectLocal, (value, oldValue) => {
    store.commit('setShippingSelect', value)
    // Автоматическая смена способа оплаты, если выбрана доставка id=4 и был payment=1
    if (paymentSelect.value == 1 && value == 4) {
        store.commit('setPaymentSelect', 2)
    }
})

// --- shippingDescription по текущему выбранному id
const shippingDescription = computed(() => {
    const type = shippingTypesSafe.value.find(s => s.id === shippingSelectLocal.value)
    return type && type.preview_text ? type.preview_text : ''
})

onMounted(() => {
    // Можно добавить авто-выбор на старте, если нужно
})

watch(
    () => store.getters.shippingTypes,
    (types) => {
        if (Array.isArray(types) && types.length > 0 && !store.getters.shippingSelect) {
            store.commit('setShippingSelect', types[0].id)
        }
    },
    { immediate: true }
)
</script>

<style scoped>
.swiper-slide-active .product-slide__img {
    border-radius: 4px;
}
</style>
